
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSignArrowDownLeft as ObiSignArrowDownLeftElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sign-arrow-down-left.js';
 
 
 

 
 export const ObiSignArrowDownLeft = createComponent({
   react: React,
   tagName: 'obi-sign-arrow-down-left',
   elementClass: ObiSignArrowDownLeftElement,
   events: {
     
   }
  });
 
 